<template>
    <div>
        <div >
        <!-- <h1>{{$t('userInfo.name')}}</h1> -->
        <!--顶部导航-->
        <navgate></navgate>
        <!--内容区域-->
        <div class="web_box">
            <div class="web_content">
                <div class="layout_box">
                    <div class="layout_left">
                        <div class="nav_title">信息公开</div>
                        <ul>
                            <li @click="secondItemClick('partyBuild')" class="check_link">党建引领</li>
                            <li @click="secondItemClick('rules')" >章程和相关制度</li>
                            <li @click="secondItemClick('rules')">年度报告</li>
                        </ul>
                    </div>
                    <!--移动端导航-->
                    <div class="m_second_level">
                        <div class="m_check">党建引领</div>
                        <div>章程和相关制度</div>
                        <div>年度报告</div>
                    </div>
                    <div class="layout_right">
                        <div class="news_h3">年度报告</div>
                        <div class="nothing">
                            <img src="../../assets/img/nothing.png">
                            <div class="no_word">暂无内容哦</div>
                        </div>
                    </div>
                </div>
            </div>
            <!--联系我们-->
            <div class="contact_box">
            <div class="web_content">
                <div class="news_title">
                <div class="news_h3">联系我们</div>
                </div>
            </div>
            </div>
        </div>
        
        
        
        </div>
        <!--<button @click="changLang">ccccc</button>-->
        <router-view/>
    </div>
    
</template>

<script>
import store from '../../store' 

export default {
  name: 'Introduce',
  components:{},
  props: {
    
  },
  
  methods:{
    
    secondItemClick(pageName){
      this.$router.push(pageName)
    },
    changLang(){
      const lang = this.$i18n.locale //获取当前页面默认使用的语言
      console.log(lang)  //控制台输出 'zh'
      // 实现中英切换
      if(lang == 'zh'){ //如果默认是中文，在用户点击时就切换到英文状态
          this.$i18n.locale = 'en'
      }else {
          this.$i18n.locale = 'zh'
      }
    }
  },
  mounted(){
    
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../assets/css/ks_foundation.less';
    @import '../../assets/css/ks_media.less';
    @import '../../assets/fonts/iconfont.css';
</style>
